export interface DefaultProjectImageProps {
  className?: string
  alt?: string
}

export const DefaultProjectImage = ({
  className = '',
  alt = 'Project without a publicly displayed page'
}: DefaultProjectImageProps) => (
  <div className={`relative overflow-hidden ${className}`}>
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      src='/img/hero/patterns/patternLavenderSoft.png'
      alt=''
      aria-hidden
      className='absolute inset-0 w-full h-full object-cover'
    />
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      src='/img/icons/default-project-icon.svg'
      alt={alt}
      className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/3 max-w-[120px] min-w-4 h-auto'
    />
  </div>
)
